import {AbstractResourceBuilder} from 'vue3-starter/src/typescript/resource/AbstractResourceBuilder';
import StrategyBriefResource from '@/brief-hub/brief/StrategyBriefResource';
import * as RawModel from '@/common/api/api-raw-types';

class StrategyBriefResourceBuilder extends AbstractResourceBuilder<StrategyBriefResource, RawModel.BriefResource> {
    protected _buildResource(data: RawModel.BriefResource): StrategyBriefResource {
        return new StrategyBriefResource({
            links: this.links,
            briefId: data.briefId,
            briefDetails: data.briefDetails,
            identityId: data.identityId,
            company: data.company,
            origin: data.origin,
            creationDate: data.creationDate,
            launchedDate: data.launchedDate,
            archivedDate: data.archivedDate,
            currentState: data.currentState,
            draftState: data.draftState,
            briefManager: data.briefManager,
            organization: data.organization,
            profileDetails: data.profileDetails,
            type: data.type,
        });
    }
}

export const strategyBriefResourceBuilder = new StrategyBriefResourceBuilder();
